export const COMPANY_INFO = {
  name: "Vognmand & Entreprenør DBM ApS",
  owner: "Nick M. H. Laursen",
  address: "Tingstedvej 30",
  city: "8850 Hjorthede",
  phone: "+45 21 41 68 08",
  phoneRaw: "21416808",
  email: "dbmapsnick@gmail.com",
  lindaName: "Linda M. H. Laursen",
  lindaRole: "Kontoransvarlig",
  lindaPhone: "+45 24 60 60 77",
  lindaEmail: "lindadbmaps@gmail.com",
  logoUrl: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/nick-logo.png"
};

export const MENU_STRUCTURE = [
  {
    label: "Forside",
    href: "/"
  },
  {
    label: "Ydelser",
    href: "/ydelser/",
    children: [
      { label: "Vognmandskørsel​", href: "/vognmandskorsel-2/" },
      { label: "Kranarbejde", href: "/kranarbejde-2/" },
      { label: "Grapning af slam og flydelag​", href: "/grapning-af-slam-og-flydelag/" },
      { label: "Containerudlejning/service", href: "/containerudlejning-service/" },
      { label: "Kornkørsel", href: "/kornkorsel/" },
      { label: "Entreprenør- / nedbrydningsopgaver​", href: "/entreprenor-nedbrydningsopgaver/" },
      { label: "Modtagelse af byggeaffald", href: "/modtagelse-af-byggeaffald/" },
      { label: "Grus udlægnings kørsel", href: "/grus-udlaegnings-korsel/" },
      { label: "Halm kørsel", href: "/halm-korsel/" },
      { label: "Stammetræs kørsel", href: "/stammetraes-korsel/" },
      { label: "Jernplade leje", href: "/jernplade-leje/" },
      { label: "Sorterings anlæg", href: "/sorterings-anlaeg/" },
      { label: "Gylletrailer 39 m³", href: "/gylletrailer-39-m3/" },
      { label: "Buffer kasse 100 m³", href: "/buffer-kasse-100-m3/" }
    ]
  },
  {
    label: "Maskiner/Materialer",
    href: "/maskiner/"
  },
  {
    label: "Om os",
    href: "/om-os/"
  },
  {
    label: "Kontakt",
    href: "/kontakt/"
  }
];

export const SERVICES_GRID = [
  {
    title: "Vognmandskørsel",
    href: "/vognmandskorsel-2/",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/2026-04-24-11-34-48.jpg"
  },
  {
    title: "Kranarbejde",
    href: "/kranarbejde-2/",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/skaermbillede-2024-04-02-kl-13-50-00.png"
  },
  {
    title: "Grapning af slam og flydelag",
    href: "/grapning-af-slam-og-flydelag/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/skaermbillede-2024-04-02-kl-13-59-11.png"
  },
  {
    title: "Containerudlejning/service",
    href: "/containerudlejning-service/",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/3-scaled.jpg"
  },
  {
    title: "Kornkørsel",
    href: "/kornkorsel/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/4-scaled.jpg"
  },
  {
    title: "Entreprenør- / nedbrydningsopgaver​",
    href: "/entreprenor-nedbrydningsopgaver/",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/5-scaled_46095121.jpg"
  },
  {
    title: "Modtagelse af byggeaffald",
    href: "/modtagelse-af-byggeaffald/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/6-scaled_9d6aad7d.jpg"
  },
  {
    title: "Grus udlægnings kørsel",
    href: "/grus-udlaegnings-korsel/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/22-scaled.jpg"
  },
  {
    title: "Halm kørsel",
    href: "/halm-korsel/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/33-scaled.jpg"
  },
  {
    title: "Stammetræs kørsel",
    href: "/stammetraes-korsel/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/44-scaled.jpg"
  },
  {
    title: "Jernplade leje",
    href: "/jernplade-leje/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/55-scaled.jpg"
  },
  {
    title: "Sorterings anlæg",
    href: "/sorterings-anlaeg/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/sorteringsanlaeg-hjemmeside-1-scaled.jpg"
  },
  {
    title: "Gylletrailer 39 m³",
    href: "/gylletrailer-39-m3/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/gylletrailer-hjemmeside-1-scaled.jpg"
  },
  {
    title: "Buffer kasse 100 m³",
    href: "/buffer-kasse-100-m3/",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/buffer-kasse-hjemmeside-scaled.jpg"
  }
];

export const TEAM_MEMBERS = [
  {
    name: "Nick M. H. Laursen",
    title: "Indehaver",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/3-1.jpg"
  },
  {
    name: "Linda M. H. Laursen",
    title: "Kontoransvarlig",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/linda-1.jpg"
  },
  {
    name: "Mads Østergaard",
    title: "Chauffør",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/2-1.jpg"
  },
  {
    name: "Knud Vestergaard",
    title: "Chauffør",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/1-1.jpg"
  },
  {
    name: "Mark Eskildsen",
    title: "Chauffør",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/mark-3.jpg"
  },
  {
    name: "Anders Petersen",
    title: "Chauffør",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/anders-2.jpg"
  },
  {
    name: "Torben Nielsen",
    title: "Chauffør",
    image: "https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/torben-nielsen-hjemmeside-1.jpg"
  }
];

export const PAGE_METADATA = {
  "/": {
    title: "Vognmand & Entreprenør DBM aps",
    ogTitle: "Forisde",
    description: "Vognmand & Entreprenør DBM Aps \t Vognmand & Entreprenør DBM aps \nDin lokale Vognmand & Entreprenør. Læs mere     \nVi udfører altid vores arbejde med præcision, og vi gør alt hvad vi kan for vores kunder føler sig tilfredse, når vi har fuldført vores opgave."
  },
  "/ydelser/": {
    title: "Ydelser – Vognmand & Entreprenør DBM aps",
    ogTitle: "Ydelser",
    description: "Vores ydelser  Vognmandskørsel  \nKranarbejde  \nGrapning af slam og flydelag  \nContainerudlejning/service  \nKornkørsel  \nEntreprenør- / nedbrydningsopgaver​  \nModtagelse af byggeaffald  Grus udlægnings kørsel  \nHalm kørsel  \nStammetræs kørsel  Jernplade leje  \nSorterings anlæg  \nGylletrailer 39 m³  Buffer kasse 100 m³  Kontakt os i dag"
  },
  "/vognmandskorsel-2/": {
    title: "Vognmandskørsel​ – Vognmand & Entreprenør DBM aps",
    ogTitle: "Vognmandskørsel​",
    description: "Vognmandskørsel​ Kontakt os her    \nVi leverer alle former for materialer:\n\nSand/bundsikring\nGrus\nKnust beton\nMuld\nHalm / korn kørsel\n\nog meget mere.\nKøb / salg / formidling af halm tilbydes."
  },
  "/kranarbejde-2/": {
    title: "Kranarbejde – Vognmand & Entreprenør DBM aps",
    ogTitle: "Kranarbejde",
    description: "Kranarbejde Kontakt os her    Nyhed: nu tilbyder vi kran arbejde med større kran med 35 tm med flyjib\nF.eks.\n\nFlytning af træer/rødder eller et legehus.\nKraning af både jord,grus og sand med vores grab.\nOpkraning af tagsten mm.\nKraning af diverse."
  },
  "/grapning-af-slam-og-flydelag/": {
    title: "Grapning af slam og flydelag​ – Vognmand & Entreprenør DBM aps",
    ogTitle: "Grapning af slam og flydelag​",
    description: "Grapning af slam og flydelag​ Kontakt os her    \nVi hjælper også gerne med at tømme din gylle tank for slam og flydelag med vores kran grab."
  },
  "/containerudlejning-service/": {
    title: "Containerudlejning/service – Vognmand & Entreprenør DBM aps",
    ogTitle: "Containerudlejning/service",
    description: "Står du og mangler en container tilbyder vi også container til forskellige formål.\nHave affald, bygge affald eller lignede. Man kan også have en fast container stående til fast leje."
  },
  "/kornkorsel/": {
    title: "Kornkørsel – Vognmand & Entreprenør DBM aps",
    ogTitle: "Kornkørsel",
    description: "Kornkørsel Kontakt os her    \nNår høsten melder sig står vi gerne for transporten af korn mm.\nVi har specielle containere vi benytter til dette formål."
  },
  "/entreprenor-nedbrydningsopgaver/": {
    title: "Entreprenør- / nedbrydningsopgaver​ – Vognmand & Entreprenør DBM aps",
    ogTitle: "Entreprenør- / nedbrydningsopgaver​",
    description: "Entreprenør- / nedbrydningsopgaver​ Kontakt os her    \nVi udfører også nedbrydning af diverse bygninger, samt bortkørsel af diverse bygge materialer."
  },
  "/modtagelse-af-byggeaffald/": {
    title: "Modtagelse af byggeaffald – Vognmand & Entreprenør DBM aps",
    ogTitle: "Modtagelse af byggeaffald",
    description: "Modtagelse af byggeaffald Kontakt os her    \nNyhed\nBeton/tegl brokker\nBlandede brokker\nJord med brokker\nRene beton fliser\nBlandet bygningsaffald til sortering\nRent haveaffald/buske\nRent sand og muldjord.\n\nHer finder du pladsen:\nHedemølle Industrivej 6, Bjerringbro\nKontakt os for pris"
  },
  "/grus-udlaegnings-korsel/": {
    title: "Grus udlægnings kørsel – Vognmand & Entreprenør DBM aps",
    ogTitle: "Grus udlægnings kørsel",
    description: "Grus udlægnings kørsel Kontakt os her    Er grusvejen fyldt med huller, så har vi en spiciallavet grus udlægning maskine til at lave grusvej."
  },
  "/halm-korsel/": {
    title: "Halm kørsel – Vognmand & Entreprenør DBM aps",
    ogTitle: "Halm kørsel",
    description: "Halm kørsel Kontakt os her    Når høsten er ved at være i hus, står vi også gerne for transporten af halmen.Vi vil også gerne købe, sælge og formidle halm for jer."
  },
  "/stammetraes-korsel/": {
    title: "Stammetræs kørsel – Vognmand & Entreprenør DBM aps",
    ogTitle: "Stammetræs kørsel",
    description: "Stammetræs kørsel Kontakt os her    Vi transporterer også stammetræ når skoven er blevet justeret"
  },
  "/jernplade-leje/": {
    title: "Jernplade leje – Vognmand & Entreprenør DBM aps",
    ogTitle: "Jernplade leje",
    description: "Jernplade leje Kontakt os her    Vi lejer også jernplader/køreplader ud, når skoven eller lignende har brug for et jævnt køre lag"
  },
  "/stobningsarbejde/": {
    title: "Støbningsarbejde – Vognmand & Entreprenør DBM aps",
    ogTitle: "Støbningsarbejde",
    description: "Vognmand & Entreprenør DBM aps \nDin lokale Vognmand & Entreprenør.    Støbningsarbejde Vi kan også tilbyde støbearbejdet.\nstøbning af fundament og sokkel\nstøbning af diverse."
  },
  "/anlaegsopgaver/": {
    title: "Anlægsopgaver – Vognmand & Entreprenør DBM aps",
    ogTitle: "Anlægsopgaver",
    description: "Vognmand & Entreprenør DBM aps \nDin lokale Vognmand & Entreprenør.    Anlægsopgaver \nStår du og skal have lavet indkørsel, have, p-plads mm."
  },
  "/kloak-og-jordarbejde/": {
    title: "Kloak- og jordarbejde​ – Vognmand & Entreprenør DBM aps",
    ogTitle: "Kloak- og jordarbejde​",
    description: "Vognmand & Entreprenør DBM aps \nDin lokale Vognmand & Entreprenør.    Kloak- og jordarbejde​ \nVi udfører også:\n\nafgravning og etablering af byggefelt\n\nudgravning af fundament\n\nOpbygning af sandpude\n\netablering af omfangsdræn\n\nalt kloakarbejde og regnvandsafledning"
  },
  "/maskiner/": {
    title: "Maskiner – Vognmand & Entreprenør DBM aps",
    ogTitle: "Maskiner",
    description: "Maskiner/Salg af materialer Kontakt os her    Maskineliste4 akslet lastbiler med kroghejs3 akslet trækker"
  },
  "/om-os/": {
    title: "Om os – Vognmand & Entreprenør DBM aps",
    ogTitle: "Om os",
    description: "Om os    Velkommen hos Vognmand & Entreprenør DBM aps Vi har beliggenhed ved Hjorthede nær Bjerringbro.Vognmand & Entreprenør forretningen er stiftet af Nick Mann Hedegaard Laursen, som har stor erfaring inden for begge områder."
  },
  "/kontakt/": {
    title: "Kontakt – Vognmand & Entreprenør DBM aps",
    ogTitle: "Kontakt",
    description: "Kontakt    Kontakt Du er velkommen til at kontakt os direkte eller via kontaktformular:Nick Mann Hedegaard Laursen Direktør/EjerTlf: 21416808Mail: dbmapsnick@gmail.com"
  }
};
